import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Input, InputGroup, Label } from 'reactstrap'
import AppError from "../../models/AppError"
import { ErrorModal } from './../ui'
import { subscriptionHelpers } from '../../dataHelpers';
import { getStorage, TOKEN_STORAGE_KEY, USER_STORAGE_KEY } from '../../dataHelpers/authenticationHelpers'
import Loader from 'react-loader-spinner'
import { NO_VALUE, ENTER_PAY_REF_NUMBER } from '../../constants'

class RenewSubsModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: props.modal,
      toggle: props.toggle,
      controllerID: props.controllerid,
      errors: [],
      refNumber: '',
      commentVal: ''
    }
    this.submitForm = this.submitForm.bind(this)
    this.renewSubscriptionPlan = props.renewSubscriptionPlan
    this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
    this.user = (props.token || JSON.parse(getStorage().getItem(USER_STORAGE_KEY)))
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      modal: nextProps.modal
    })
  }

  dismissError(error) {
    let errors = this.state.errors.filter((e) => e !== error)
    this.setState({ errors, loading: false })
  }

  async submitForm(e) {
    e.preventDefault()
    this.setState({ loading: true })
    let { refNumber, commentVal, controllerID } = this.state
    let randomPaymentId = Math.floor(1000000000 + Math.random() * 9000000000) //create 10 digit random numbers
    let paidBy = this.user.email
    if (!refNumber || !refNumber.length) {
      let appError = new AppError(NO_VALUE, ENTER_PAY_REF_NUMBER)
      await this.setState({ errors: [appError], loading: false })
      return
    }
    try {
      let savePaymentResponse = await subscriptionHelpers.savePayment(this.token, refNumber, commentVal, randomPaymentId, paidBy, controllerID)
      if (!savePaymentResponse.error) {
        await this.setState({ loading: false })
        this.renewSubscriptionPlan()
      } else {
        this.setState({ errors: [savePaymentResponse.error] })
      }
    }
    catch (error) {
      console.log(error.message)
    }
  }

  render() {
    let { loading, modal, errors, refNumber, commentVal } = this.state
    return (
      <div>
        {loading ?
          <Loader type="TailSpin" width={60} height={60} /> :
          <Modal isOpen={modal} toggle={this.props.toggle} className={this.props.className}>
            <ModalHeader toggle={this.props.toggle}>Renew Subscription Plan</ModalHeader>
            <ModalBody>
              <Form onSubmit={this.submitForm} className="col-lg-12 col-md-8 col-sm-10">
                <FormGroup>
                  <div className="text-left">
                    <Label>Payment Reference Number&ensp;<span style={{ color: '#ff0000' }}>*</span></Label>
                  </div>
                  <InputGroup>
                    <Input type="refnumber"
                      placeholder={`Payment Reference Number`}
                      value={refNumber}
                      onChange={(evt) => this.setState({ refNumber: evt.target.value })}
                      maxLength={50}
                    />
                  </InputGroup>
                  <br />
                  <div className="text-left">
                    <Label>Comment</Label>
                  </div>
                  <InputGroup>
                    <Input type="textarea"
                      placeholder={`Comment`}
                      value={commentVal}
                      onChange={(evt) => this.setState({ commentVal: evt.target.value })}
                      maxLength={150}
                    />
                  </InputGroup>
                </FormGroup>
                <Button className="mt-3">Save</Button>
                <br />
              </Form>
            </ModalBody>           
          </Modal>
        }
        {errors.map((appError, idx) =>
          <ErrorModal key={`error-${appError.text}-${idx}`}
            modal={true}
            toggle={() => (this.dismissError(appError))}
            text={appError.text}
            title={appError.title} />
        )}
      </div>
    )
  }
}

export default RenewSubsModal


// WEBPACK FOOTER //
// ./src/components/ui/RenewSubsModal.js